module.exports = __webpack_public_path__ + "static/media/type_contact.c205af79.png";